<template>
  <div>
    <ReportOfSicknessCard
      class='mb-4'
      :employee="employee"
      :reportOfSickness="reportOfSickness" />

    <RecoveryForm
      :isEditing="true"
      :reportOfSickness="reportOfSickness" />

    <div style='float: right' class='mt-4'>
      <Button primary class='mr-3' @click="this.handleCancelClick">{{ 'buttons.cancel' | translate }}</Button>
      <Button secondary @click="this.handleContinueClick" :disabled="!isValid" :hoverErrors="continueHoverErrors">{{ 'buttons.next-step' | translate }}</Button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ValidationCodes from '@/views/helpers/validation-codes';
import EditRecoveryConstants from '@/views/constants/recovery-edit';

import RecoveryForm from '@/views/components/recovery-new/RecoveryForm.vue';
import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

export default {
  name: 'EditRecoveryInputForm',

  components: {
    RecoveryForm,
    ReportOfSicknessCard,
    Button
  },
  props: {
    reportOfSickness: Object,
    employee: Object
  },
  computed: {
    ...mapGetters({
      validations: 'editRecoveryValidations',
      requiredFields: 'editRecoveryRequiredFields'
    }),
    isValid () {
      return this.requiredFields.isValid() && this.validations.isValid();
    },
    continueHoverErrors () {
      const requiredFieldErrors =
        this.requiredFields.isValid() ? [] : [ this.$t('errors.provide-all-required-fields') ];
      const noChangesErrors = this.validations.errorsFor('Recovery')
        .filter(e => e.code === ValidationCodes.NO_CHANGES)
        .map(e => this.$t(e.message));
      return _.union(requiredFieldErrors, noChangesErrors);
    }
  },
  methods: {
    handleCancelClick () {
      this.$store.dispatch(EditRecoveryConstants.Actions.Cancel.DO);
    },
    handleContinueClick () {
      this.$store.dispatch(EditRecoveryConstants.Actions.Navigate.DO,
        EditRecoveryConstants.Views.EditRecoveryConfirmation);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.theme--light.v-divider {
  border-color: $gray-lighten-1;
}
</style>
